import { Pipe, PipeTransform } from '@angular/core'
import { ShoppableServiceLabel, ShoppableServiceModel, ShoppableServicesLabelsService } from '@mmx/shared'
import { map } from 'rxjs/operators'

@Pipe({
  name: 'shoppableServiceLabels',
  standalone: false,
})
export class ShoppableServiceLabelsPipe implements PipeTransform {

  constructor(private labelsService: ShoppableServicesLabelsService) {
  }

  transform(value: ShoppableServiceModel) {
    if (value.labelIds) {
      return this.labelsService.labels$.pipe(
        map((labels) => {
          const labelsMap = labels.reduce((acc: Record<string, ShoppableServiceLabel>, label) => {
            acc[label.id] = label
            return acc
          }, {})

          return value.labelIds.map((id) => labelsMap[id]?.title).join(', ')
        }),
      )
    }

    return null
  }
}
